export default class PongBrokerAction {
  constructor(username) {
    this.action = 'PongBrokerAction';
    this.username = username;
    this.client = `AGENT-${username}`;
  }
}
